import { create } from 'zustand'

export const useAddMemberStore = create(set => ({
  isError: false,
  setIsError: newValue => set({ isError: newValue }),
}))
